"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var CalculatorContextInterface_1 = require("./CalculatorContextInterface");
var CalculatorEmailView_1 = __importDefault(require("./view/CalculatorEmailView"));
var CalculatorNicknameView_1 = __importDefault(require("./view/CalculatorNicknameView"));
var CalculatorPaymentView_1 = __importDefault(require("./view/CalculatorPaymentView"));
var CalculatorPromocodeView_1 = __importDefault(require("./view/CalculatorPromocodeView"));
var NotificationView_1 = __importDefault(require("./view/NotificationView"));
var CalculatorTotalPrice_1 = __importDefault(require("./view/CalculatorTotalPrice"));
var CalculatorServerView_1 = __importDefault(require("./view/CalculatorServerView"));
var CalculatorInputCostView_1 = __importDefault(require("./view/CalculatorInputCostView"));
var VolumeDiscountView_1 = __importDefault(require("./view/VolumeDiscountView"));
var CalculatorInputReciveView_1 = __importDefault(require("./view/CalculatorInputReciveView"));
var DiscountPriceView_1 = __importDefault(require("./view/DiscountPriceView"));
var DiscountSaveView_1 = __importDefault(require("./view/DiscountSaveView"));
var CalculatorCheckoutView_1 = __importDefault(require("./view/CalculatorCheckoutView"));
var InputDirectionEnum_1 = require("../../../../enums/InputDirectionEnum");
var ExchangerUtils_1 = require("../../../../utils/ExchangerUtils");
var CalculatorPhoneView_1 = __importDefault(require("./view/CalculatorPhoneView"));
var CalculatorFractionView_1 = __importDefault(require("./view/CalculatorFractionView"));
var CalculatorDeliveryView_1 = __importDefault(require("./view/CalculatorDeliveryView"));
var CalculatorNeedContactView_1 = __importDefault(require("./view/CalculatorNeedContactView"));
var CalculatorSetupValue_1 = __importDefault(require("./view/CalculatorSetupValue"));
var SaleUtils_1 = require("../../../../utils/SaleUtils");
var react_i18next_1 = require("react-i18next");
var GameRating_1 = __importDefault(require("./components/GameRating/GameRating"));
var GamePriceList_1 = __importDefault(require("./components/GamePriceList/GamePriceList"));
var CalculatorMinOrder_1 = __importDefault(require("./view/CalculatorMinOrder"));
var react_ga4_1 = __importDefault(require("react-ga4"));
var __1 = require("../../../..");
var CurrencyUtils_1 = require("../../../../utils/CurrencyUtils");
var CustomOrderView_1 = __importDefault(require("../../view/CustomOrderView"));
var APP_DEBUG_MODE = true;
var Calculator = function () {
    var _a;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    // email користувача
    var _c = (0, react_1.useState)(), _email = _c[0], _setEmail = _c[1];
    var cc = require('currency-codes');
    var dc = (_a = document.getElementById("react-calculator")) === null || _a === void 0 ? void 0 : _a.getAttribute('data-currency-default');
    // базова валюта калькулятора
    var _d = (0, react_1.useState)(typeof dc === 'string'
        ? parseInt(dc)
        : parseInt(cc.code('UAH').number)), _defaultCurrency = _d[0], _setDefaultCurrency = _d[1];
    // промокод
    var _e = (0, react_1.useState)(), _promocode = _e[0], _setPromocode = _e[1];
    // нікнейм користувача
    var _f = (0, react_1.useState)(""), _nickname = _f[0], _setNickname = _f[1];
    // дані про платіжну систему, яку обрав корситувач для способу оплати
    var _g = (0, react_1.useState)(), _payment = _g[0], _setPayment = _g[1];
    // дані про обранний сервер
    var _h = (0, react_1.useState)(), _server = _h[0], _setServer = _h[1];
    // дані про гру
    var _j = (0, react_1.useState)(), _game = _j[0], _setGame = _j[1];
    // сумма яку повинен заплати користувач за моенти
    var _k = (0, react_1.useState)(), _payAmount = _k[0], _setPayAmount = _k[1];
    // к-сть момен які отримає користувач
    var _l = (0, react_1.useState)(), _payRecive = _l[0], _setPayRecive = _l[1];
    // к-сть момен які отримає користувач з урахуванням знижки
    var _m = (0, react_1.useState)(), _payReciveDiscount = _m[0], _setPayReciveDiscount = _m[1];
    // обмінник валют
    var _o = (0, react_1.useState)(), _exchanger = _o[0], _setExchanger = _o[1];
    // напрямок прорахунку в калькуляторі
    var _p = (0, react_1.useState)(InputDirectionEnum_1.InputDirectionEnum.NONE), _inputDirection = _p[0], _setInputDirection = _p[1];
    // сумма оплати в базовій валюті, з ції сумми прораховується знижки за об'єм
    var _q = (0, react_1.useState)(0), _calculatedAmounted = _q[0], _setCalculatedAmounted = _q[1];
    var methods = (0, react_hook_form_1.useForm)();
    // відцоток знижки за об'єм
    var _r = (0, react_1.useState)(0), volumeDiscount = _r[0], setVolumeDiscount = _r[1];
    // флаг, що вказує чи потрібно показувати заповнення фракції
    var _s = (0, react_1.useState)(false), isFraction = _s[0], setIsFraction = _s[1];
    // флаг, що вказує чи потрібно показувати заповнення методу даставки
    var _t = (0, react_1.useState)(false), isDelivery = _t[0], setIsDelivery = _t[1];
    //
    var _u = (0, react_1.useState)(), nightPromocode = _u[0], setNightPromocode = _u[1];
    //
    var _v = (0, react_1.useState)(), _sale = _v[0], _setSale = _v[1];
    var _w = (0, react_1.useState)(), _appOrder = _w[0], _setAppOrder = _w[1];
    var _x = (0, react_1.useState)(), _serverList = _x[0], _setServerList = _x[1];
    var _y = (0, react_1.useState)(), _serverDefaultList = _y[0], _setServerDefultList = _y[1];
    var onSubmit = function (data) {
        //console.log(data);
        // return;
        axios_1.default.post("/app/order/create", data)
            .then(function (response) {
            var _a, _b, _c;
            if (response.status == 200) {
                if (__1.SETUP_LOCAL_APP) {
                    react_ga4_1.default.initialize(__1.GA_ID);
                    react_ga4_1.default.event("begin_checkout", {
                        currency: CurrencyUtils_1.CurrencyUtils.symbolName((_a = value.payment) === null || _a === void 0 ? void 0 : _a.currency_code),
                        value: value.payAmount,
                        coupon: (_b = value.promocode) === null || _b === void 0 ? void 0 : _b.name,
                        items: [{
                                item_id: data.server_id,
                                item_name: (_c = value.server) === null || _c === void 0 ? void 0 : _c.app_locale_name
                            }]
                    });
                }
                //console.log(response);
                window.location.href = response.data.redirect;
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    };
    var value = (0, react_1.useMemo)(function () { return ({
        email: _email,
        promocode: _promocode,
        nickname: _nickname,
        payment: _payment,
        defaultCurrency: _defaultCurrency,
        server: _server,
        game: _game,
        payAmount: _payAmount,
        payRecive: _payRecive,
        exchanger: _exchanger,
        inputDirection: _inputDirection,
        calculatedAmounted: _calculatedAmounted,
        payReciveDiscount: _payReciveDiscount,
        sale: _sale,
        appOrder: _appOrder,
        serverList: _serverList,
        serverDefaultList: _serverDefaultList,
        setServerDefaultList: _setServerDefultList,
        setServerList: _setServerList,
        setPayment: _setPayment,
        setNickname: _setNickname,
        setPromocode: _setPromocode,
        setEmail: _setEmail,
        setServer: _setServer,
        setGame: _setGame,
        setPayAmount: _setPayAmount,
        setPayRecive: _setPayRecive,
        setExchanger: _setExchanger,
        setInputDirection: _setInputDirection,
        setCalculatedAmounted: _setCalculatedAmounted,
        setPayReciveDiscount: _setPayReciveDiscount,
        setSale: _setSale,
        setAppOrder: _setAppOrder
    }); }, [
        _email, _promocode, _nickname, _payment, _payRecive, _sale,
        _defaultCurrency, _server, _game, _payAmount, _appOrder,
        _exchanger, _inputDirection, _calculatedAmounted, _payReciveDiscount, _serverList, _serverDefaultList,
        _setNickname, _setEmail, _setPromocode, _setPayRecive, _setSale, _setServerList, _setServerDefultList,
        _setPayment, _setServer, _setGame, _setPayAmount,
        _setExchanger, _setInputDirection, _setCalculatedAmounted, _setPayReciveDiscount, _setAppOrder
    ]);
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/app/order/promocode/night/")
            .then(function (response) {
            if (response.status == 200) {
                setNightPromocode(response.data);
            }
            else {
                setNightPromocode(undefined);
            }
        }).catch(function (error) {
            setNightPromocode(undefined);
        });
        var formNode = document.getElementById("react-calculator");
        var gameId = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-game-id');
        if (gameId) {
            axios_1.default.get("/app/game/".concat(gameId))
                .then(function (response) {
                if (response.status == 200) {
                    _setGame(response.data);
                }
            }).catch(function (error) {
                console.log("error", error);
            });
        }
        if (formNode) {
            var _wmu = formNode.getAttribute('data-wmu');
            var _wmz = formNode.getAttribute('data-wmz');
            var _wme = formNode.getAttribute('data-wme');
            (_wme && _wmu && _wmz) && _setExchanger({
                wme: parseFloat(_wme),
                wmu: parseFloat(_wmu),
                wmz: parseFloat(_wmz),
                usdt: parseFloat(_wmz)
            });
            var hash = formNode.getAttribute('date-sale-hash');
            axios_1.default.get("/app/order/sale/".concat(hash))
                .then(function (response) {
                if (response.status == 200) {
                    //console.log("sale responce",response.data);
                    _setSale(response.data);
                }
            }).catch(function (error) {
                console.log("error", error);
            });
            var orderHash = formNode.getAttribute('date-order-hash');
            axios_1.default.get("/app/order/current/".concat(orderHash))
                .then(function (response) {
                if (response.status == 200) {
                    //console.log("order responce",response.data);
                    _setAppOrder(response.data);
                }
            }).catch(function (error) {
                console.log("error", error);
            });
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!value.game) {
            return;
        }
        // означає що користувач ще не обрав сервер на калькулятрі
        if (!value.server) {
            return;
        }
        // очищаємо інормацію про к-сть знижки за об'єм
        setVolumeDiscount(0);
        // обираємо тип валюти, в якій проводяться розрахунки
        var calculatedCurrencyCode = ((_a = value.payment) === null || _a === void 0 ? void 0 : _a.currency_code)
            ? value.payment.currency_code
            : value.defaultCurrency;
        if (value.inputDirection === InputDirectionEnum_1.InputDirectionEnum.COINTS) {
            if (!value.payRecive || isNaN(value.payRecive)) {
                return;
            }
            var setAmount = value.payRecive * value.server.default_price;
            if (value.exchanger) {
                setAmount = setAmount / ExchangerUtils_1.ExchangerUtils.conver(value.exchanger, calculatedCurrencyCode);
            }
            //setAmount = +setAmount.toFixed(2);
            value.setPayAmount(setAmount);
        }
        if (!value.payAmount || isNaN(value.payAmount)) {
            return;
        }
        if (APP_DEBUG_MODE) {
            console.log("calculatedAmounted:", value.payAmount);
        }
        var calculatedAmounted = value.payAmount;
        /**
         * якщо встановленний обмінник, то перераховуємо введену сумму
         * в базову валюту
         * */
        if (value.exchanger) {
            calculatedAmounted = calculatedAmounted * ExchangerUtils_1.ExchangerUtils.conver(value.exchanger, calculatedCurrencyCode);
        }
        value.setCalculatedAmounted(calculatedAmounted);
        // прораховуємо базову к-сть монет без урахування знижки
        var calculetedCoints = +(calculatedAmounted / value.server.default_price).toFixed(2);
        if (APP_DEBUG_MODE) {
            console.log("calculetedCoints:", value.payAmount);
        }
        if (!value.sale) {
            // прораховуємо знижку за об'єм
            var _vd = SaleUtils_1.SaleUtils.vd(value.game, calculatedAmounted);
            /*
            if (calculatedAmounted >= 500 && calculatedAmounted < 1000) {
                _vd = value.game.price_500;
            } else if (calculatedAmounted >= 1000 && calculatedAmounted < 1500) {
                _vd = value.game.price_1000;
            } else if (calculatedAmounted >= 1500 && calculatedAmounted < 2500) {
                _vd = value.game.price_1500;
            } else if (calculatedAmounted >= 2500) {
                _vd = value.game.price_2500;
            }
            */
            if (APP_DEBUG_MODE) {
                console.log("_vd:", _vd);
            }
            setVolumeDiscount(_vd);
            var discountCoints = 0; // к-сть момент зі знижкою
            console.log("calculetedCoints: ", calculetedCoints);
            discountCoints = calculetedCoints + ((calculetedCoints * _vd) / 100);
            if (APP_DEBUG_MODE) {
                console.log("discountCoints:", discountCoints);
            }
            // дадаємо кість момент за накопичену знижку по імейлу
            if (value.email) {
                discountCoints = discountCoints + ((calculetedCoints * value.email.discount) / 100);
                if (APP_DEBUG_MODE) {
                    console.log("email:", value.email.discount);
                }
                if (APP_DEBUG_MODE) {
                    console.log("discountCoints:", discountCoints);
                }
            }
            // дадаємо кість момент за знижку по промокоду
            if (value.promocode) {
                discountCoints = discountCoints + ((calculetedCoints * value.promocode.value) / 100);
                if (APP_DEBUG_MODE) {
                    console.log("promocode:", value.promocode.value);
                }
                if (APP_DEBUG_MODE) {
                    console.log("discountCoints:", discountCoints);
                }
            }
            // дадаємо кість момент за знижку по нічній акції
            if (nightPromocode) {
                discountCoints = discountCoints + ((calculetedCoints * nightPromocode.value) / 100);
                if (APP_DEBUG_MODE) {
                    console.log("nightPromocode:", nightPromocode.value);
                }
                if (APP_DEBUG_MODE) {
                    console.log("discountCoints:", discountCoints);
                }
            }
            value.setPayReciveDiscount(discountCoints);
        }
        if (value.sale) {
            value.setPayRecive(calculetedCoints);
            value.setPayReciveDiscount(value.sale.coins);
        }
        if (APP_DEBUG_MODE) {
            console.log("inputDirection:", value.inputDirection);
        }
        switch (value.inputDirection) {
            case InputDirectionEnum_1.InputDirectionEnum.COINTS:
                //value.setPayAmount(va);
                break;
            case InputDirectionEnum_1.InputDirectionEnum.MONEY:
                // встановлюємо базову к-сть монет
                value.setPayRecive(calculetedCoints);
                break;
            case InputDirectionEnum_1.InputDirectionEnum.SALE:
                value.setPayRecive(calculetedCoints);
                break;
        }
    }, [value]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (value.game) {
            (((_a = value.game.app_locale_fractions) === null || _a === void 0 ? void 0 : _a.length) > 0) && setIsFraction(true);
            (((_b = value.game.app_locale_delivery) === null || _b === void 0 ? void 0 : _b.length) > 0) && setIsDelivery(true);
            if (__1.SETUP_LOCAL_APP) {
                react_ga4_1.default.initialize(__1.GA_ID);
                react_ga4_1.default.event("view_item", {
                    items: [{
                            item_name: value.game.name,
                            item_id: value.game.id,
                        }]
                });
            }
        }
    }, [value.game]);
    function onErrors(data) {
        console.log("on erorrs", data);
    }
    return (react_1.default.createElement(CalculatorContextInterface_1.CalculatorContext.Provider, __assign({}, methods, { value: value }),
        react_1.default.createElement(react_hook_form_1.FormProvider, __assign({}, methods),
            react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit, onErrors) },
                react_1.default.createElement(CalculatorSetupValue_1.default, null),
                react_1.default.createElement("div", { className: "__busket" },
                    react_1.default.createElement(NotificationView_1.default, null),
                    react_1.default.createElement("div", { className: "__row" },
                        react_1.default.createElement(CalculatorServerView_1.default, null),
                        isFraction && react_1.default.createElement(CalculatorFractionView_1.default, null),
                        react_1.default.createElement(CalculatorPaymentView_1.default, null),
                        !isFraction && isDelivery && react_1.default.createElement(CalculatorDeliveryView_1.default, null),
                        value.game && value.game.flag_need_nickname ? react_1.default.createElement(CalculatorNicknameView_1.default, null) : ""),
                    react_1.default.createElement("div", { className: "__row" },
                        react_1.default.createElement(CalculatorInputCostView_1.default, null),
                        react_1.default.createElement(CalculatorInputReciveView_1.default, null),
                        value.game && value.game.flag_need_promocode ? react_1.default.createElement(CalculatorPromocodeView_1.default, null) : "",
                        react_1.default.createElement(CalculatorEmailView_1.default, null)),
                    react_1.default.createElement("div", { className: "__row" },
                        (value.payment && value.payment.required_phone)
                            ? react_1.default.createElement(CalculatorPhoneView_1.default, null)
                            : '',
                        isFraction && isDelivery && react_1.default.createElement(CalculatorDeliveryView_1.default, null),
                        value.game && value.game.flag_need_contact ? react_1.default.createElement(CalculatorNeedContactView_1.default, null) : ''),
                    react_1.default.createElement("div", { className: "__checkout" },
                        react_1.default.createElement(VolumeDiscountView_1.default, { disocunt: volumeDiscount }),
                        react_1.default.createElement(DiscountPriceView_1.default, null),
                        react_1.default.createElement(DiscountSaveView_1.default, null),
                        react_1.default.createElement(CalculatorCheckoutView_1.default, null)),
                    react_1.default.createElement("div", { className: "__row-final-price" },
                        react_1.default.createElement(CalculatorMinOrder_1.default, null),
                        react_1.default.createElement(CalculatorTotalPrice_1.default, null)))),
            react_1.default.createElement("div", { className: "wrap-rating-row" },
                react_1.default.createElement("div", { className: "__custon-rating " },
                    react_1.default.createElement(GameRating_1.default, null)),
                react_1.default.createElement("div", { className: "__custon-order " },
                    react_1.default.createElement(CustomOrderView_1.default, null))),
            react_1.default.createElement(GamePriceList_1.default, null))));
};
exports.default = Calculator;
